// Second-level frame node = "SubSection". Mono micro-caps label with count;
// shows "no cards yet" placeholder when empty (or a clickable GAP chip when
// mece_required and empty).

export interface SubSectionProps {
  label: string;
  count: number;
  isGap: boolean;
  onGapClick?: () => void;
  children?: React.ReactNode;
}

export function SubSection({
  label, count, isGap, onGapClick, children,
}: SubSectionProps) {
  const empty = count === 0;
  return (
    <div style={{ marginBottom: 10 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 8,
          padding: '4px 0 6px',
        }}
      >
        <span
          className="mono"
          style={{
            fontSize: 10.5,
            letterSpacing: '.12em',
            fontWeight: 700,
            color: empty ? 'var(--ink-3)' : 'var(--ink-2)',
          }}
        >
          {label.toUpperCase()}
        </span>
        <span
          className="mono"
          style={{ fontSize: 10, color: 'var(--ink-3)', letterSpacing: '.05em' }}
        >
          · {count}
        </span>
        {isGap && (
          <button
            onClick={onGapClick}
            className="mono"
            style={{
              fontSize: 9,
              letterSpacing: '.08em',
              fontWeight: 700,
              color: 'var(--amber)',
              padding: '1px 6px',
              border: '1px solid var(--amber)',
              borderRadius: 3,
              background: 'var(--amber-soft)',
              cursor: 'pointer',
              marginLeft: 4,
            }}
            title="empty — open probe questions"
          >
            GAP
          </button>
        )}
      </div>
      {empty ? (
        <div
          style={{
            fontSize: 11.5,
            color: 'var(--ink-3)',
            fontStyle: 'italic',
            paddingLeft: 4,
            paddingBottom: 6,
          }}
        >
          no cards yet
        </div>
      ) : (
        children
      )}
    </div>
  );
}
